import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { de } from "./de";

/**
 * i18next init (DE-111, ADR-FE-003). German-only for now (NF-021); a CI
 * key-completeness gate (scripts/check-i18n.ts) guards against missing keys.
 * Typed resources (resources.d.ts) can be layered on as the catalog grows.
 */
void i18n.use(initReactI18next).init({
  lng: "de",
  fallbackLng: "de",
  defaultNS: "translation",
  resources: {
    de: { translation: de },
  },
  interpolation: { escapeValue: false },
});

export default i18n;
